/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_COUPON, UPLOAD_FILE } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateCouponMethods extends IPluginMethodMap {
  getCreateCouponProps(args: any): Promise<any>;
  uploadFile(image: any, formData?: any): Promise<any>;
}

export class CreateCouponService implements IAgentPlugin {
  readonly methods: ICreateCouponMethods;

  constructor() {
    this.methods = {
      getCreateCouponProps: this.getCreateCouponProps.bind(this),
      uploadFile: this.uploadFile.bind(this),
    };
  }

  private isValidHttpUrl(str: string) {
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(str);
  }

  private getFileTypeFromBase64(base64String: string) {
    const matches = base64String.match(/^data:image\/(\w+)/);
    if (matches && matches.length === 2) {
      return matches[1];
    }
    return null;
  }

  async uploadFile(image: any, formData?: any): Promise<any> {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let fileType = "png";

    if (!image) return "";

    if (Array.isArray(image)) {
      const results: string[] = [];
      for (const item of image) {
        const uploaded = await this.uploadFile(item, formData);
        if (uploaded) {
          results.push(uploaded);
        }
      }
      return results;
    }

    const dataString = typeof image === "string" ? image : image?.base64 ?? "";
    if (!dataString) return "";

    if (this.isValidHttpUrl(dataString)) {
      return dataString;
    }

    fileType = this.getFileTypeFromBase64(dataString) ?? "png";

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPLOAD_FILE,
          variables: {
            name: fileType,
            data: dataString,
            category1: "discount",
            category2: formData?.name ?? formData?.couponCode ?? "discountCoupon",
            addBandName: true,
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.uploadFile) {
          return res?.data?.uploadFile;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }

    return "";
  }

  async getCreateCouponProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log(args, "Args678900");
    try {
      if (client) {
        const payload = { ...args };

        if (
          payload?.image &&
          typeof payload.image === "string" &&
          payload.image.trim() !== ""
        ) {
          payload.image = await this.uploadFile(payload.image, payload);
        }

        if (
          payload?.img &&
          typeof payload.img === "string" &&
          payload.img.trim() !== ""
        ) {
          payload.img = await this.uploadFile(payload.img, payload);
        }

        const res = await client.mutate({
          mutation: CREATE_COUPON,
          variables: {
            data: {
              ...payload,
            },
          },
          fetchPolicy: "no-cache",
        });
        console.log("Create Coupon final data", res?.data);
        console.log(
          "Create Coupon final data in xyuuh",
          res?.data?.createDiscount
        );
        return res?.data?.createDiscount;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}

